import { BO, BusinessObjectBase, NonUniqueModelDataError, PropertyChangedJoinPoint, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { OssVatRateModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';
import { propertyChangedJoinPointFilter } from '../common/property-changed/property-changed-filter';

@BO({ modelType: OssVatRateModel })
export class OssVatRateBO extends BusinessObjectBase<OssVatRateModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.configureReadonlyRules();
        this.registerPropertyChanges();
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation)) {
            const violations: { property: string; violation: NonUniqueModelDataError }[] = [];
            if (sameValues(conflict.objectProperties ?? [], ['name', 'countryId'])) {
                violations.push({
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.oss-vat-rate.validation.name.non-unique'),
                });
            }
            if (sameValues(conflict.objectProperties ?? [], ['symbol', 'countryId'])) {
                violations.push({
                    property: 'symbol',
                    violation: new NonUniqueModelDataError('business.oss-vat-rate.validation.symbol.non-unique')
                });
            }
            if (violations.length > 0) {
                this.addExternalRuleViolations({
                    [this.model.sun]: violations
                });
            }
        }
    }

    private registerPropertyChanges(): void {
        this.registerListening(this.weaver.register(PropertyChangedJoinPoint, propertyChangedJoinPointFilter(this)(OssVatRateModel, ['default'])(
            _ => {
                if (this.model.default === true) {
                    this.model.active = true;
                }
            }
        )));
    }

    private configureReadonlyRules(): void {
        this.readonly.addRule(
            [[OssVatRateModel, 'default']],
            [[OssVatRateModel, 'active']],
            ctx => ctx.source.default
        );
        this.readonly.addRule([
            [OssVatRateModel, 'countryId'],
            [OssVatRateModel, 'name'],
            [OssVatRateModel, 'symbol'],
            [OssVatRateModel, 'rate']],
            ctx => ctx.source.inUse
        );
    }
}
